export default {
      id: "operative-usage",
      viewBox: "0 0 69.97 69.97",
      url: __webpack_public_path__ + "sprite.svg#operative",
      toString: function () {
        return this.url;
      }
    }